import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import DateItem from './DateItem';
import {
  months,
  publicationTypes,
  thesisStatus,
  thesisTypes,
} from '../../../utils/constants';
import { getReportType } from '../../../services/reportService';
import { useCallback } from 'react';
import Loading from '../../common/loading';
import { useSnackbar } from 'notistack';

const Summary = ({ data, onType, url: urlPDF }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    year,
    month: monthId,
    period,
    type,
    projectSlug,
    projectName,
    executedActivities,
    publications,
    theses,
    results,
    conclusions,
    recommendations,
    percentage,
  } = data;
  const { name } = months.find((m) => m.id === monthId);

  const getNameTypePublication = (typePublication) => {
    console.log('typePublication: ', typePublication);
    if (typePublication === 0) return '';
    const pub = publicationTypes.find((pub) => pub.id === typePublication);
    return pub.name;
  };

  const getNameTypeThesis = (typeThesis) => {
    if (typeThesis === 0) return '';
    const thesis = thesisTypes.find((thesis) => thesis.id === typeThesis);
    return thesis.name;
  };

  const getNameStatusThesis = (statusThesis) => {
    if (statusThesis === 0) return '';
    const thesis = thesisStatus.find((thesis) => thesis.id === statusThesis);
    return thesis.name;
  };

  const populateType = useCallback(
    async (projectSlug, year, monthId) => {
      setIsLoading(true);
      try {
        const { data } = await getReportType(projectSlug, year, monthId);
        onType(data.type);
      } catch (ex) {
        enqueueSnackbar(`${ex.response}`, { variant: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [enqueueSnackbar]
  );

  useEffect(() => {
    populateType(projectSlug, year, monthId);
  }, [projectSlug, year, monthId, populateType]);

  return (
    <>
      <Loading open={isLoading} />
      <SummaryContainer>
        <SummaryItem>
          <TitleItem>Fechas seleccionadas</TitleItem>
          <DateItem data={year} label='Año' />
          <DateItem data={name} label='Mes' />
          <DateItem data={period} label='Período Académico' />
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Tipo de reporte: </TitleItem>
          <span>{type}</span>
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Proyecto</TitleItem>
          <ContentItem>
            <strong>Nombre: </strong> {projectName || 'No seleccionado'}
          </ContentItem>
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Actividades Ejecutadas</TitleItem>
          <Table>
            <TableHead>
              <TableRow>
                <Th>#</Th>
                <Th>Nombre actividad</Th>
                <Th>Semanas</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {executedActivities.length > 0 &&
              executedActivities[0].name !== '' ? (
                executedActivities.map((act, index) => (
                  <TableRow key={index}>
                    <TableColumn>{++index}</TableColumn>
                    <TableColumn>{act.name || ''}</TableColumn>
                    <TableColumn>
                      {act.week.map((w, index) =>
                        w === true ? (
                          <span key={index}>{`S${++index} `}</span>
                        ) : null
                      )}
                    </TableColumn>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableColumn colSpan={4}>Sin datos</TableColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Publicaciones</TitleItem>
          <Table>
            <TableHead>
              <TableRow>
                <Th>#</Th>
                <Th>Tipo</Th>
                <Th>Título publicación</Th>
                <Th>Revista/Editorial/ISBN/Congreso</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {publications.length > 0 && publications[0].name !== '' ? (
                publications.map((pub, index) => (
                  <TableRow key={index}>
                    <TableColumn>{++index}</TableColumn>
                    <TableColumn>
                      {getNameTypePublication(pub.type || 0)}
                    </TableColumn>
                    <TableColumn>{pub.name || ''}</TableColumn>
                    <TableColumn>{pub.info || ''}</TableColumn>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableColumn colSpan={4}>Sin datos</TableColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Trabajos de titulación o Tesis</TitleItem>
          <Table>
            <TableHead>
              <TableRow>
                <Th>#</Th>
                <Th>Tipo</Th>
                <Th>Estado</Th>
                <Th>Tema</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {theses.length > 0 && theses[0].name !== '' ? (
                theses.map((thesis, index) => (
                  <TableRow key={index}>
                    <TableColumn>{++index}</TableColumn>
                    <TableColumn>
                      {getNameTypeThesis(thesis.type || 0)}
                    </TableColumn>
                    <TableColumn>
                      {getNameStatusThesis(thesis.status || 0)}
                    </TableColumn>
                    <TableColumn>{thesis.name || ''}</TableColumn>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableColumn colSpan={4}>Sin datos</TableColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </SummaryItem>
        <SummaryItem>
          <TitleItem>Datos Finales</TitleItem>
          <DateItem data={percentage} label='Porcentaje de avance' />
          <DateItem data={results} label='Resultados' />
          <DateItem data={conclusions} label='Conclusiones' />
          <DateItem data={recommendations} label='Recomendaciones' />
        </SummaryItem>
      </SummaryContainer>
    </>
  );
};

const ContentItem = styled.div`
  display: flex;
`;

const styles = css`
  border: 1px solid black;
`;

const SummaryContainer = styled.section`
  margin: 0 2em 0;
  padding-top: 2em;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
`;

const SummaryItem = styled.div`
  width: 90%;
  margin-bottom: 2em;
`;

const Table = styled.table`
  border: 1px solid black;
  width: 80%;
  border-collapse: collapse;
`;

const TableBody = styled.tbody`
  ${styles}
`;

const TableRow = styled.tr`
  ${styles}
`;

const TableHead = styled.thead`
  ${styles}
  text-transform: uppercase;
  font-weight: bold;
`;

const TableColumn = styled.td`
  ${styles} text-align: center;
`;

const Th = styled.th`
  ${styles}
  text-transform: uppercase;
  font-weight: bold;
`;

const TitleItem = styled.strong`
  text-transform: uppercase;
`;

export default Summary;
